import React, { useRef, useContext, useState, useEffect } from "react";
import { pDataProvider, pCommProviderSelection, pDB_user_roles, pServer } from "../utils/parameters";
import { useCommProvider } from "../api/CommProvider";

import data_web_info_local from "../assets/bbdd/web_info.json";
import data_user_local from "../assets/bbdd/data_user.json";

import data_lemma_local from "../assets/bbdd/data_lemma.json";
import data_meaning_local from "../assets/bbdd/data_meaning.json";
import data_glosses_local from "../assets/bbdd/data_gloss.json";
import data_sentence_local from "../assets/bbdd/data_sentence.json";
import data_answer_local from "../assets/bbdd/data_answer.json";
import data_question_local from "../assets/bbdd/data_question.json";

import data_web_info_error_connection from "../assets/web_info_error_connection.json";

var lodash = require('lodash');
const stringSimilarity = require('string-similarity');


const DataProviderContext = React.createContext();

export function useDataProvider() {
  return useContext(DataProviderContext);
}

export function DataProvider({ children }) {
  // STATUS
  const [ serviceStatus, setServiceStatus] = useState({'web': false,'user': false,'data': false,'connection_attempt': 0});

  // WEB_INFO
  const [json_web_info, set_json_web_info] = useState(null);
  
  // USER_INFO
  const [currentUser, setCurrentUser] = useState(null);  // Filtered info currentUser - important data: 'uid', 'isAnonymous'
  const [json_data_USER, set_json_data_USER] = useState(null);
  const [currentUserRole, setCurrentUserRole] = useState(pDB_user_roles.none);

  const [token_id, setToken_id] = useState(null);

  // DATA LEMMA, MEANING Y GLOSSES
  const [json_data_lemma, set_json_data_lemma] = useState({});
  const [json_data_meaning, set_json_data_meaning] = useState({});
  const [json_data_glosses, set_json_data_glosses] = useState({});

  const [json_data_sentence, set_json_data_sentence] = useState({});

  const [json_data_answer, set_json_data_answer] = useState({});
  const [json_data_question, set_json_data_question] = useState({});

  const { comm_activateListenerUserAuth, comm_updateUserTokenAuth, comm_getJSONWebInfo, comm_getJSONDataUser, comm_getJSONData, commProviderSelected, comm_configure_base_url, base_url_data } = useCommProvider();
  const interval_token = useRef(null);
  const interval_update = useRef(null);

  const [device_information, set_device_information] = useState({}); 

  useEffect(() => {
    const unsubscribe_auth = comm_activateListenerUserAuth(setCurrentUser, setToken_id, serviceStatus, setServiceStatus);
    return () => {
      unsubscribe_auth();
    };
  },[]);

  const updateInfo = async () => {
    // Información básica del navegador y plataforma
    const isMobile = /Mobi/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);

    const navigatorInfo = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      isMobile: isMobile,
      isAndroid: isAndroid
    };

    // Información de la webcam
    let webcamInfo = {};
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const webcams = devices.filter(device => device.kind === 'videoinput');
      webcamInfo = { webcams: webcams.length };
    } catch (error) {
      webcamInfo = { error: 'Webcam not accessible' };
    }

    // Información de la pantalla
    const screenInfo = {
      width: window.screen.width,
      height: window.screen.height,
      orientation: window.screen.orientation.type
    };

    set_device_information({ ...navigatorInfo, ...webcamInfo, ...screenInfo });
  };


  // useEffect(() => {
  //   console.log("🚀 ~ file: DataProvider.js:122 ~ DataProvider ~ json_data_lemma:", json_data_lemma)
  // }, [json_data_lemma]);
  // useEffect(() => {
  //   console.log("🚀 ~ file: DataProvider.js:122 ~ DataProvider ~ json_data_meaning:", json_data_meaning)
  // }, [json_data_meaning]);
  // useEffect(() => {
  //   console.log("🚀 ~ file: DataProvider.js:122 ~ DataProvider ~ json_data_glosses:", json_data_glosses)
  // }, [json_data_glosses]);
  


  // Its neccesary update the before 60 minutes
  useEffect(() => {
    if (currentUser !== null){
      if (interval_token.current === null) {
        interval_token.current = setInterval(() => {
          comm_updateUserTokenAuth(currentUser, setToken_id);
        }, (29 * 60 * 1000)); // update each 29 minutes - comm_updateUserTokenAuth for update the token
      }

      if (interval_update.current === null) {
        interval_update.current = setInterval(() => {

          setServiceStatus(prevState => ({
            ...prevState,
            connection_attempt: prevState.connection_attempt + 1
          }));

        }, (1000)); // update each 1 second
      } 

    }
    return () => {
      clearInterval(interval_token.current);
      clearInterval(interval_update.current);
    }

  },[currentUser]);

  useEffect(() => {
    console.log("🚀 ~ file: DataProvider.js:74 ~ DataProvider ~ token_id:", token_id)
  },[token_id]);
  

  useEffect(() => {
    async function obtainData(){
      console.log('OBTAIN DATA - serviceStatus values: ' + serviceStatus['web'] + ' - ' + serviceStatus['data'] + ' - ' + serviceStatus['user'] + ' - ' + serviceStatus['connection_attempt']);
      try{
        if (serviceStatus['web'] == false){
          const json_web_info = await comm_getJSONWebInfo()
          if (json_web_info !== undefined){
            set_json_web_info(json_web_info)

            if ((json_web_info['server_status']=='UP') || (json_web_info['server2_status']=='UP')){
              setServiceStatus({...serviceStatus, 'web': true})
              if (json_web_info['server_status']=='DOWN'){
                console.log('SERVER2 UP')
                comm_configure_base_url(pCommProviderSelection.SERVER_BACKUP)
              }
            }
          }

        }else if (serviceStatus['data'] == false && serviceStatus['web'] === true){

          set_json_data_lemma(await comm_getJSONData("data_lemma_1716460673.json"))
          set_json_data_meaning(await comm_getJSONData("data_meaning_1716460673.json"))
          set_json_data_glosses(await comm_getJSONData("data_gloss_1716460673.json"))
          set_json_data_sentence(await comm_getJSONData("data_sentence_1716460673.json"))
          set_json_data_answer(await comm_getJSONData("data_answer_1716460673.json"))
          set_json_data_question(await comm_getJSONData("data_question_1716460673.json"))
          setServiceStatus({...serviceStatus, 'data': true})

        }else if (serviceStatus['web'] === true && serviceStatus['user'] == false){
          const json_user_data = await comm_getJSONDataUser(token_id, currentUser)
          if (json_user_data !== undefined && json_user_data !== null ){
            switch (json_user_data['role']) {
              case 'REGISTRADO':
                setCurrentUserRole(pDB_user_roles.registered);
                break;
              case 'COLABORADOR':
                setCurrentUserRole(pDB_user_roles.collaborator);
                break;
              case 'ANOTADOR':
                setCurrentUserRole(pDB_user_roles.annotator);
                break;
              case 'ADMIN':
                setCurrentUserRole(pDB_user_roles.admin);
                break;
              case 'INVITADO':
                setCurrentUserRole(pDB_user_roles.invitated);
                break;
              default:
                throw Error ('[DataProvider] Field role with inconsistencies.')
            }
            set_json_data_USER(json_user_data)
            setServiceStatus({...serviceStatus, 'user': true})
          }
        }
      }catch(err){
        console.log('ERROR', err)
      }
    }

    if (token_id !== null) {
      obtainData();
    }
    
    if (serviceStatus['connection_attempt'] < 5){
      console.log('connection_attempts: ' + serviceStatus['connection_attempt'])
    }else{
      console.log('[DATA_PROVIDER] - ERROR STOP INTERVAL: ',serviceStatus['connection_attempt'])
      clearInterval(interval_update.current);
      //set_json_web_info(data_web_info_error_connection)
    }

    if (serviceStatus['web'] == true && serviceStatus['data'] == true && serviceStatus['user'] == true){
      console.log('[DATA_PROVIDER] - ALL DATA LOADED')
      clearInterval(interval_update.current);
    }
    
  },[serviceStatus]);


  function force_use_local_json(){

    console.log('USE LOCAL JSON');
    set_json_web_info(data_web_info_local);
    set_json_data_USER(data_user_local);
    set_json_data_lemma(data_lemma_local);
    set_json_data_meaning(data_meaning_local);
    set_json_data_glosses(data_glosses_local);
    set_json_data_sentence(data_sentence_local);
    set_json_data_answer(data_answer_local);
    set_json_data_question(data_question_local);

  }

  // function removeAccents(str) {
  //   return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  // }

  function findSimilarWords(inputWord) {

    const lemmaList = lodash(json_data_lemma).pickBy((value) => value.visibility).map('label').value();
    const lemmaList_id = lodash(json_data_lemma).pickBy((value) => value.visibility).keys().value();

    const formattedInputWord = inputWord.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const formattedLemmaList = lemmaList.map((lemma) => lemma.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
  
    const similarities = stringSimilarity.findBestMatch(formattedInputWord, formattedLemmaList);
    
    // Obtener hasta tres mejores coincidencias
    const bestMatches = similarities.ratings
      .filter(match => match.rating > 0.5) // Filtrar por similitud superior al umbral
      .slice(0, 3); // Tomar hasta tres mejores coincidencias
  
    const isSimilar = bestMatches.length > 0;
    const similarWords = bestMatches.map(match => lemmaList[formattedLemmaList.indexOf(match.target)]);
    const isSimilarIds = bestMatches.map(match => lemmaList_id[formattedLemmaList.indexOf(match.target)]);
      
    return {
      isSimilar,
      similarWords,
      isSimilarIds,
    };
  }

  function getListAllLemmasLabelAvailable() {
    return lodash(json_data_lemma)
      .pickBy((value) => value.visibility)
      .map('label')
      .value();
  }

  function getListAllLemmasAvailable() {
    return lodash(json_data_lemma)
      .pickBy((value) => value.visibility)
      .keys()
      .value();
  }

  // function getListAllLemmasAvailable(lang) {
  //   return _.chain(json_data_lemma)
  //       .pickBy(value => value.visibility) // Filtra por visibilidad
  //       .filter(value => value.lang && value.lang.includes(lang)) // Filtra por idioma
  //       .keys() // Obtiene las claves
  //       .value();
  // }

  function getListAllGlossesAvailable() {
    return lodash(json_data_glosses)
      .pickBy((value) => value.visibility)
      .keys()
      .value();
  }

  // Used in: SEARCH BY TEXT & FAV
  function getListNameDefinitions(arr_lemmas) {

    const filtered_array = lodash.isUndefined(arr_lemmas) ? [] : lodash.filter(arr_lemmas, lemma_id => lodash.has(json_data_lemma, lemma_id))

    return lodash.map(filtered_array, (k, index) => {
      let aux = {
        id: index,
        _id: k,
        name: lodash.get(json_data_lemma, [k, pDataProvider.label], ''),
        accesible: lodash.get(json_data_lemma, [k, 'accesible'], ''),
        definition: lodash(json_data_lemma[k][pDataProvider.arr_meanings])
          .map(k2 => lodash.get(json_data_meaning, [k2, 'definition'], ''))
          .value()
      };
      return aux;
    });
  }

  function getListNameDefinitionsCategories(arr_lemmas) {

    const filtered_array = lodash.isUndefined(arr_lemmas) ? [] : lodash.filter(arr_lemmas, lemma_id => lodash.has(json_data_lemma, lemma_id))
    let lemma_data = lodash.map(filtered_array, (k, index) => {
      let aux = {
        id: index,
        _id: k,
        name: lodash.get(json_data_lemma, [k, pDataProvider.label], ''),
        accesible: lodash.get(json_data_lemma, [k, 'accesible'], ''),
        arr_categories: lodash.get(json_data_lemma, [k, 'arr_meanings'], ''),
        definition: lodash(json_data_lemma[k][pDataProvider.arr_meanings])
          .map(k2 => lodash.get(json_data_meaning, [k2, 'definition'], ''))
          .value()
      };
      return aux;
    });

    lemma_data.map(k =>{
        if (Array.isArray(k['arr_categories'])) {
          k['arr_categories'] = k['arr_categories'].map(k2 => {
            return json_data_meaning[k2]['category'].includes('_') ? json_data_meaning[k2]['category'].split('_').slice(1).join('_') : json_data_meaning[k2]['category']
          });
        }
      }
    )
    

    return lemma_data
  }

  // Used in: SEARCH BY TEXT & FAV
  function getListNameDefinitionsDate(arr_history) {
    // Array history entries
    // FORMAT : {'lemma': xxxxx, 'date': XXXXXXX}

    const filtered_array = lodash.isUndefined(arr_history) ? [] : lodash.filter(arr_history, item => lodash.has(json_data_lemma, item.lemma));
    return lodash.map(filtered_array, (k, index) => {
      const lemma_id = k['lemma'];
      let aux = {
        id: index,
        _id: lemma_id,
        name: lodash.get(json_data_lemma, [lemma_id, pDataProvider.label], ''),
        accesible: lodash.get(json_data_lemma, [lemma_id, 'accesible'], ''),
        date: k['date'],
        definition: lodash(json_data_lemma[lemma_id][pDataProvider.arr_meanings])
          .map(k2 => lodash.get(json_data_meaning, [k2, 'definition'], ''))
          .value()
      };
      return aux;
    });
  }

  // Used in: SEARCH BY TEXT
  function getListGlossesByName(lemma_id) {
    let signList = [];
    let counter_elements = 0;
    json_data_lemma[lemma_id][pDataProvider.arr_meanings].forEach((k_meaning, idx_meaning) => {
      try {
        json_data_meaning[k_meaning][pDataProvider.arr_glosses].forEach((k_gloss, idx_gloss) => {
          let aux = {};
          aux["id"] = counter_elements;
          counter_elements = counter_elements + 1;
          aux["uid"] = json_data_glosses[k_gloss][pDataProvider.uid];
          aux["name"] = k_gloss;
          aux["url_vid_sign"] = comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, k_gloss)
          try {
            aux["type"] = json_data_glosses[k_gloss][pDataProvider.type];
          } catch {
            aux["type"] = "";
          }
          signList.push(aux);
        });
      } catch {}

      try {
        json_data_meaning[k_meaning][pDataProvider.arr_variants].forEach((k_gloss, idx_gloss) => {
          let aux = {};
          aux["id"] = counter_elements;
          counter_elements = counter_elements + 1;
          aux["uid"] = json_data_glosses[k_gloss][pDataProvider.uid];
          aux["name"] = k_gloss;
          aux["url_vid_sign"] = comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, k_gloss);
          aux["type"] = "";
          try {
            aux["type"] = json_data_glosses[k_gloss][pDataProvider.type];
          } catch {
            aux["type"] = "";
          }
          signList.push(aux);
        });
      } catch {}
    });
    return signList;
  }

  function genEntryByLemma(arr_lemma_id, arr_prob = []) {
    let entry = {};
    entry["elements"] = [];
    entry["prob"] = [];
    arr_lemma_id.forEach((lemma_id, idx) => {
      entry["elements"].push(lemma_id);
      try {
        entry["prob"].push(arr_prob[idx]);
      } catch {
        entry["prob"].push(0);
      }

      entry[lemma_id] = [];
      json_data_lemma[lemma_id][pDataProvider.arr_meanings].forEach((meaning_id) => {
        try {
          entry[lemma_id].push(meaning_id);
          entry[meaning_id] = [];
          json_data_meaning[meaning_id][pDataProvider.arr_glosses].forEach((gloss_id) => {
            try {
              if (json_data_glosses[gloss_id][pDataProvider.visibility]) entry[meaning_id].push(gloss_id);
            } catch {}
          });
          json_data_meaning[meaning_id][pDataProvider.arr_variants].forEach((gloss_id) => {
            try {
              if (json_data_glosses[gloss_id][pDataProvider.visibility]) entry[meaning_id].push(gloss_id);
            } catch {}
          });
        } catch {}
      });
    });
    return entry;
  }

  function getLemmaByGloss(gloss_id) {
  
    const meaning = json_data_glosses[gloss_id][pDataProvider.arr_meanings][0] !== undefined ? json_data_glosses[gloss_id][pDataProvider.arr_meanings][0] : json_data_glosses[gloss_id][pDataProvider.arr_variants][0]
    const lemma = json_data_meaning[meaning][pDataProvider.arr_lemmas][0]
    return lemma;
  }

  function getLemmaMeaningByGloss(gloss_id) {
  
    const meaning = json_data_glosses[gloss_id][pDataProvider.arr_meanings][0] !== undefined ? json_data_glosses[gloss_id][pDataProvider.arr_meanings][0] : json_data_glosses[gloss_id][pDataProvider.arr_variants][0]
    const lemma = json_data_meaning[meaning][pDataProvider.arr_lemmas][0]
    return {
      lemma,
      meaning
    };
  }


  function genEntryByGloss(arr_gloss_uid, arr_prob = [], jumpGlossID = false) {

    let position_gloss_uid = {
      'lemma': [],
      'meaning': [],
      'gloss': [],
    }

    let arr_gloss_id = [];
    if (jumpGlossID){
      console.log("🚀 ~ genEntryByGloss ~ jumpGlossID:", jumpGlossID)
      position_gloss_uid['gloss'] = arr_gloss_uid
      arr_gloss_id = arr_gloss_uid
    }else{
      console.log("🚀 ~ genEntryByGloss ~ jumpGlossID:", jumpGlossID)
      arr_gloss_uid.map(( gloss_uid, idx) => {
        Object.keys(json_data_glosses).forEach((k) => {
          if (json_data_glosses[k][pDataProvider.uid] === gloss_uid) {
            arr_gloss_id.push(k);
            position_gloss_uid['gloss'][idx] = k
          }
        });
      });
    }
    
    let arr_lemma_id = [];
    arr_gloss_id.map((gloss_id, idx) => {
      try {
        let meaning_id = "";
        if (json_data_glosses[gloss_id][pDataProvider.arr_meanings].length > 0) {
          meaning_id = json_data_glosses[gloss_id][pDataProvider.arr_meanings][0];
        } else {
          meaning_id = json_data_glosses[gloss_id][pDataProvider.arr_variants][0];
        }
        arr_lemma_id.push(json_data_meaning[meaning_id][pDataProvider.arr_lemmas][0]);
        position_gloss_uid['meaning'][idx] = meaning_id;
      } catch {}
    });

    let dialog_elements = {};
    dialog_elements["elements"] = [];
    dialog_elements["prob"] = [];
    arr_lemma_id.map((lemma_id, idx) => {
      dialog_elements["elements"].push(lemma_id);
      position_gloss_uid['lemma'][idx] = lemma_id;
      try {
        dialog_elements["prob"].push(arr_prob[idx]);
      } catch {
        dialog_elements["prob"].push(0);
      }
    });

    dialog_elements["elements"].forEach((lemma_id, idx) => {
      dialog_elements[lemma_id] = [];
      json_data_lemma[lemma_id][pDataProvider.arr_meanings].forEach((meaning_id) => {
        try {
          dialog_elements[lemma_id].push(meaning_id);
          dialog_elements[meaning_id] = [];
          json_data_meaning[meaning_id][pDataProvider.arr_glosses].forEach((gloss_id) => {
            try {
              dialog_elements[meaning_id].push(gloss_id);
            } catch {}
          });
          json_data_meaning[meaning_id][pDataProvider.arr_variants].forEach((gloss_id) => {
            try {
              dialog_elements[meaning_id].push(gloss_id);
            } catch {}
          });
        } catch {}
      });
    });

    dialog_elements["inference_glosses"] = arr_gloss_id

    // console.log("🚀 ~ file: DataProvider.js:383 ~ genEntryByGloss ~ dialog_elements:", dialog_elements)
    // console.log("🚀 ~ file: DataProvider.js:383 ~ genEntryByGloss ~ position_gloss_uid:", position_gloss_uid)

    // return {entry, position_gloss_uid};
    return {
      dialog_elements,
      position_gloss_uid
    };
  }

  function genEntryByGlossID(arr_gloss_id, arr_prob = []) {

    let position_gloss_uid = {
      'lemma': [],
      'meaning': [],
      'gloss': [],
    }

    let arr_lemma_id = [];
    arr_gloss_id.map((gloss_id, idx) => {
      try {
        let meaning_id = "";
        if (json_data_glosses[gloss_id][pDataProvider.arr_meanings].length > 0) {
          meaning_id = json_data_glosses[gloss_id][pDataProvider.arr_meanings][0];
        } else {
          meaning_id = json_data_glosses[gloss_id][pDataProvider.arr_variants][0];
        }
        arr_lemma_id.push(json_data_meaning[meaning_id][pDataProvider.arr_lemmas][0]);
        position_gloss_uid['meaning'][idx] = meaning_id;
      } catch {}
    });

    let dialog_elements = {};
    dialog_elements["elements"] = [];
    dialog_elements["prob"] = [];
    arr_lemma_id.map((lemma_id, idx) => {
      dialog_elements["elements"].push(lemma_id);
      position_gloss_uid['lemma'][idx] = lemma_id;
      try {
        dialog_elements["prob"].push(arr_prob[idx]);
      } catch {
        dialog_elements["prob"].push(0);
      }
    });

    dialog_elements["elements"].forEach((lemma_id, idx) => {
      dialog_elements[lemma_id] = [];
      json_data_lemma[lemma_id][pDataProvider.arr_meanings].forEach((meaning_id) => {
        try {
          dialog_elements[lemma_id].push(meaning_id);
          dialog_elements[meaning_id] = [];
          json_data_meaning[meaning_id][pDataProvider.arr_glosses].forEach((gloss_id) => {
            try {
              dialog_elements[meaning_id].push(gloss_id);
            } catch {}
          });
          json_data_meaning[meaning_id][pDataProvider.arr_variants].forEach((gloss_id) => {
            try {
              dialog_elements[meaning_id].push(gloss_id);
            } catch {}
          });
        } catch {}
      });
    });

    dialog_elements["inference_glosses"] = arr_gloss_id

    // console.log("🚀 ~ file: DataProvider.js:383 ~ genEntryByGloss ~ dialog_elements:", dialog_elements)
    // console.log("🚀 ~ file: DataProvider.js:383 ~ genEntryByGloss ~ position_gloss_uid:", position_gloss_uid)

    // return {entry, position_gloss_uid};
    return {
      dialog_elements,
      position_gloss_uid
    };
  }

  
    

  function sortArrDictsByField(arr_dict, field) {
    return lodash.sortBy(arr_dict, field);
  }


  // OBTAIN VIDEO - PUBLIC REPOSITORY 
    // Example
    // pServer.base_url_data + / + "vid_sign/rec1ROuGywBebIF4r.mp4"
    // https://lse.gts.uvigo.es:56076/data/vid_sign/rec1ROuGywBebIF4r.mp4

    function comm_getPublicURLVideoData(type_vid, id){
      console.log("🚀 ~ comm_getPublicURLVideoData ~ comm_getPublicURLVideoData:", comm_getPublicURLVideoData)
      console.log("🚀 ~ comm_getPublicURLVideoData ~ comm_getPublicURLVideoData:", type_vid)
      console.log("🚀 ~ comm_getPublicURLVideoData ~ comm_getPublicURLVideoData:", id)

      let url_out = null
      try{
      switch(type_vid) {
          case pDataProvider.dir_vid_definition:
              url_out = base_url_data +"/"+json_data_meaning[id][pDataProvider.dir_vid_definition];
              break;
          case pDataProvider.dir_vid_sign:
              url_out = base_url_data +"/"+json_data_glosses[id][pDataProvider.dir_vid_sign];
              break;
          case pDataProvider.dir_vid_sentence:
              url_out = base_url_data +"/"+json_data_sentence[id][pDataProvider.dir_vid_sentence];
              break;
          case pDataProvider.dir_vid_versusKeypoints:
              url_out = base_url_data +"/"+pDataProvider.dir_vid_versusKeypoints+"/"+id+".mp4";
              break;
          case pDataProvider.dir_vid_versusOverlay:
              url_out = base_url_data +"/"+pDataProvider.dir_vid_versusOverlay+"/"+id+".mp4";
              break;

          case pDataProvider.dir_vid_answer:
              url_out = base_url_data +"/vid_answer/"+id+".mp4";
              // url_out = base_url_data +"/"+json_data_answer[id][pDataProvider.dir_vid_answer];
              break;
          case pDataProvider.dir_vid_question:
              url_out = base_url_data +"/vid_question/"+id+".mp4";
              // url_out = base_url_data +"/"+json_data_question[id][pDataProvider.dir_vid_question];
              break;

          case pDataProvider.dir_vid_donate_sentence:
                url_out = base_url_data +"/video_donate_sentence/"+id+".mp4";
                // url_out = base_url_data +"/"+json_data_question[id][pDataProvider.dir_vid_question];
                break;

          case pDataProvider.dir_vid_donate_fingerspelling:
            url_out = base_url_data +"/video_donate_fingerspelling/"+id+".mp4";
            break;
          

          default:
              throw Error ('[comm_getPublicURLVideoData] Error type_vid incorrect: ' + type_vid + ' - id: ' + id + '')
      }
      } catch (error) {
          console.error("[DATA_PROVIDER] 🚀 ~ file: DataProvider.js:382 ~ comm_getPublicURLVideoData ~ error", error)
      }

      console.log("🚀 ~ comm_getPublicURLVideoData ~ url_out:", url_out)
      return url_out
  }

  function comm_getPublicURLJSONData(type_json, id){
      let url_out = null
      try{
      switch(type_json) {
          case pDataProvider.dir_json_sentence:
              url_out = base_url_data + '/' + json_data_sentence[id][pDataProvider.dir_json_sentence];
              break;
          default:
              throw Error ('[comm_getPublicURLVideoData] Error type_json incorrect: ' + type_json + ' - id: ' + id + '')
      }
      } catch (error) {
          console.error("[DATA_PROVIDER] 🚀 ~ file: DataProvider.js:382 ~ comm_getPublicURLJSONData ~ error", error)
      }
      return url_out
  }



  const value = {
    // setServiceStatus,
    // serviceStatus,

    getListAllLemmasAvailable,
    getListAllLemmasLabelAvailable,
    getListAllGlossesAvailable,
    getListNameDefinitions,
    getListNameDefinitionsCategories,
    getListNameDefinitionsDate,
    // getListNameCounterGlosses,
    getListGlossesByName,
    genEntryByLemma,
    genEntryByGloss,
    genEntryByGlossID,
    sortArrDictsByField,
    getLemmaByGloss,
    getLemmaMeaningByGloss,
    
    json_web_info, 
    json_data_USER, 
    json_data_lemma,
    json_data_meaning,
    json_data_glosses,
    json_data_sentence,
    json_data_answer,
    json_data_question, 
    set_json_data_USER,
    // set_json_web_info,
    // set_json_data_lemma,
    // set_json_data_meaning,
    // set_json_data_glosses,

    json_web_info,

    currentUser, 
    setCurrentUser,
    token_id,
    currentUserRole,
    setToken_id,

    setServiceStatus,
    serviceStatus,

    force_use_local_json,

    comm_getPublicURLVideoData,
    comm_getPublicURLJSONData,
    findSimilarWords,

  };

  return <DataProviderContext.Provider value={value}>{children}</DataProviderContext.Provider>;
}
